<template>
  <div class="user-modal__login">
    <form action="#" @submit.prevent="submit" novalidate>
      <div v-if="!step2" class="floating-input-wrapper">
        <input v-model="phone" type="text" name="phone" class="floating-input" aria-label="הזן מס טלפון נייד" required>
        <span v-bind:class="errors.phone ? 'label-error floating-label' : 'floating-label'">
                    הזן מס טלפון נייד
                    <span class="required-star">*</span>
            </span>
      </div>
      <div v-if="step2" class="floating-input-wrapper">
        <input v-model="code" type="text" name="code" class="floating-input" required>
        <span v-bind:class="errors.code ? 'label-error floating-label' : 'floating-label'">
                    הזן קוד שקבלת בסמס
                    <span class="required-star">*</span>
            </span>
      </div>
      <div v-if="hasErrors" style="text-align: center;color: red">
        <template v-if="!step2">
          טלפון שגויים
        </template>
        <template v-if="step2">
          הקוד שהזנת שגוי
        </template>
      </div>
      <button type="submit" class="btn-black user-btn__login" aria-label="התחבר">
        התחבר
      </button>
      <div class="user-modal__links">
        <a v-on:click="(event) => onClickButton(event, 'Login')">
          בטל
        </a>
      </div>
    </form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'Sms',
  computed: {
    hasErrors() {
      return Object.values(this.errors).length > 0
    },
  },
  data() {
    return {
      phone: '',
      code: '',
      step2: false,
      errors: {}
    }
  },
  mounted() {
  },
  methods: {
    submit() {
      const that = this
      this.errors = {};
      if (!this.step2) {
        axios.post('/customer-sms', {
          phone: this.phone,
        })
          .then((response) => {
            that.step2 = true
          })
          .catch((e) => {
            this.errors = e.response.data.errors;
          })
      } else{
        axios.post('/customer-sms-confirm', {
          phone: this.phone,
          code: this.code,
        })
          .then((response) => {
            if(response.data.success) {
              window.location.reload();
            }
          })
          .catch((e) => {
            this.errors = e.response.data.errors;
          })
      }
    },
    onClickButton(event, value) {
      this.$emit('clicked', value)
    },
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/_mixins.scss";

.th__user {
  &__modal {
    &__login {
      p {
        margin-bottom: cvw(36px);
      }

    }
  }
}

@include bp(md) {
  .th__user {
    &__modal {
      &__login {
        p {
          margin-bottom: cvwt(22px);
        }

      }
    }
  }
}

@include bp(sm) {
  .th__user {
    &__modal {
      &__login {
        p {
          margin-bottom: cvm(19px);
        }

      }
    }
  }
}
</style>
